export default __webpack_public_path__ + "static/media/jackets.dbb445ff.jpg";